import { render } from "./TransactionView.vue?vue&type=template&id=206d592c&scoped=true"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"

import "./TransactionView.vue?vue&type=style&index=0&id=206d592c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206d592c"]])

export default __exports__